<template>
    <div></div>
</template>
<script>
import { globals } from "../../main";
import {
    mapGetters, mapActions
} from "vuex";
export default {
    data() {
        return {

        };
    },
    computed: {
        ...mapGetters(["shortenUrlResponse",]),
    },

    watch: {
        shortenUrlResponse: function () {
            window.location = this.shortenUrlResponse.url
        },
    },

    mounted() {
        globals.$loader.show();
        this.getShortenUrl({
            identifier: this.$route.params.id 
        })
    },

    methods: {
        ...mapActions(["getShortenUrl"]),
    }
}
</script>